import { render, staticRenderFns } from "./purchase-contract-info.vue?vue&type=template&id=5a977e46&"
import script from "./purchase-contract-info.vue?vue&type=script&lang=js&"
export * from "./purchase-contract-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a977e46')) {
      api.createRecord('5a977e46', component.options)
    } else {
      api.reload('5a977e46', component.options)
    }
    module.hot.accept("./purchase-contract-info.vue?vue&type=template&id=5a977e46&", function () {
      api.rerender('5a977e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/purchase-contract-info.vue"
export default component.exports